import { render } from "./Atencion.vue?vue&type=template&id=30a4bb92&scoped=true"
import script from "./Atencion.vue?vue&type=script&lang=js"
export * from "./Atencion.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=30a4bb92&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=30a4bb92&scoped=true&lang=css"
import "./Atencion.vue?vue&type=style&index=2&id=30a4bb92&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a4bb92"]])

export default __exports__